<template>
  <div>
    <div class="page-title my-3"><mdb-icon icon="clipboard-list" /> 게시판</div>
    <article-list :articles="articles" :startIndex="startIndex" @select="onSelect"/>
    <pagination v-if="pagination" :pageInfo="pagination" @change-page="moveToPage"/>
    <div v-if="isLogin" class="text-right">
      <mdb-btn @click="clickWrite" icon="edit" class="">쓰기</mdb-btn>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import pagination from '@/views/common/Pagination';
import articleList from '@/components/article/ArticleList';
import ArticleAction from '@/store/modules/article/ActionType.js';
export default {
  name: 'Board',
  components: { pagination, articleList },
  data: () => ({
    articles: [],
    pagination: undefined
  }),
  computed: {
    ...mapState('training', ['training']),
    ...mapGetters('auth', ['isLogin']),
    startIndex: function () {
      return this.pagination ? this.pagination.totalCount - this.pagination.startIndex : 0
    }
  },
  methods: {
    clickWrite () {
      this.$router.push({ name: 'BoardEdit' })
    },
    async moveToPage (page) {
      if (this.training && this.training._id) {
        const category = 'board';
        const data = await this.$Article.list({ page, category, training: this.training._id });
        this.articles = data.articles
        this.pagination = data.pagination
      } else {
        this.articles = []
        this.pagination = {}
      }
    },
    onSelect (articleId) {
      this.$router.push({ name: 'BoardDetail', params: { _id: articleId } })
    }
  },
  created () { this.moveToPage(1) },
  watch: {
    training (newValue) {
      this.moveToPage(1);
    }
  }
}
</script>

<style>
th {
  font-weight: bolder;
}
</style>
